<div class="input-component"
     #inputZone
     [ngClass]="{'pristine': pristine, 'valid': (validStatus$ | async), 'invalid': (invalidStatus$ | async), 'disabled': disabled}">
    <div class="input-wrapper"
         (click)="onClick()">
        <input readonly
               type="text"
               class="input-field"
               [attr.required]="required"
               [(ngModel)]="value"
               [id]="fieldId"
               [name]="name"
               [attr.value]="value"
               [ngModelOptions]="updateOn" />
        <div class="zone-arrow"
             [title]="this.direction === this.arrowDirection.CLOSED ? 'open' : 'close and apply'">
            <span class="dropdown-arrow">
                <i class="fas fa-triangle"
                   [ngClass]="{'fa-rotate-180': this.direction === this.arrowDirection.CLOSED}"
                   aria-hidden="true">
                </i>
            </span>
        </div>
    </div>
</div>
